import HelpOutlineIcon from '@mui/icons-material/InfoOutlined'
import type { ReactElement } from 'react'
import { useTheme } from '../theme'
import TooltipIcon from './TooltipIcon'

interface HelpTooltipIconProps {
  text: string
  icon?: ReactElement
}

const HelpTooltipIcon = ({ text, icon }: HelpTooltipIconProps) => {
  const theme = useTheme()

  return (
    <TooltipIcon
      text={text}
      icon={
        icon || (
          <HelpOutlineIcon
            fontSize={'small'}
            sx={{ color: theme.palette.text.secondary }}
          />
        )
      }
    />
  )
}

export default HelpTooltipIcon
